<ui-modal
  class="copy-leg-modal"
  [isOpened]="isModalOpened"
  modalTitle="Copy leg"
  (isOpenedChange)="modalChanged($event)"
>
  <form [formGroup]="form" autocomplete="off">
    <div class="copy-leg-modal__input-container">
      <label>
        into product type:
        <app-selector
          class="copy-leg"
          [isSearch]="true"
          formControlName="productType"
          [passedItems]="productTypeOptions"
        ></app-selector>
      </label>
    </div>
    <div class="modal-footer">
      <button
        class="ui-button primary"
        type="submit"
        [ngClass]="this.form.valid ? 'ng-valid' : 'ng-invalid'"
        [disabled]="!this.form.valid"
        [style.cursor]="!this.form.valid ? 'not-allowed' : 'default'"
        (click)="copyLegSelected()"
      >
        Copy
      </button>
    </div>
  </form>
</ui-modal>
